module.exports = __webpack_public_path__ + "img/aakash.2cf529c5.png";